namespace Vit.Reports {
    export class ReportManager {
        public static RenderReport(reportId: string, element: string, language: string) {

            var reportClass = ReportManager.FindReportClass(reportId);
            if (reportClass == null)
                reportClass = ReportBase;

            ReportBase.Current = new reportClass();
            ReportBase.Current.renderReport(reportId, element, language);
        }
        public static ShowReportDialog(reportId: string, reportData: any, dialogTitle: string) {
            if (window["Stimulsoft"]) {
                ReportManager.ShowReportDialog2(reportId, reportData, dialogTitle);
            }
            else {
                $('<link/>', {
                    rel: 'stylesheet',
                    type: 'text/css',
                    href: '/css/Stimulsoft/stimulsoft.viewer.office2013.darkgrayblue.css'
                }).appendTo('head');

                $.getScript("/Scripts/stimulsoft.reports.js")
                    .done(() => {
                        $.getScript("/Scripts/stimulsoft.viewer.js")
                            .done(() => {
                                ReportManager.ShowReportDialog2(reportId, reportData, dialogTitle);
                            });
                    });
            }
        }
        private static ShowReportDialog2(reportId: string, reportData: any, dialogTitle: string) {
            var reportClass = ReportManager.FindReportClass(reportId);
            if (reportClass == null)
                reportClass = ReportBase;

            var element = "dynamic-report-" + Math.floor(Math.random() * 100000).toString();
            var reportDiv = document.createElement("div");
            reportDiv.id = element;
            reportDiv.dir = 'ltr';
            document.body.appendChild(reportDiv);

            ReportBase.Current = new reportClass();
            ReportBase.Current.renderReport(reportId, element, Q.Culture.shortName, reportData);


            var wWidth = $(window).width();
            var dWidth = wWidth * 0.9;
            var wHeight = $(window).height();
            var dHeight = wHeight * 0.9;

            $("#" + element).dialog({
                modal: true,
                title: dialogTitle,
                width: dWidth,
                height: dHeight,
                draggable: false,
                resizable: false,
                close: () => {
                    $("#" + element).dialog('destroy').remove()
                }
            });
            //var dialogElement = $("#" + element);
            //Q.Router.dialog(dialogElement, dialogElement, () => {
            //    return "";
            //});
        }
        private static FindReportClass(reportId: string): any {
            for (var i in Q.Config.rootNamespaces) {
                var ns = Q.Config.rootNamespaces[i];
                var classFullName = `${ns}.${reportId}`;
                var cp = classFullName.split('.');
                var p = 0;
                var item = window;
                while (p < cp.length) {
                    item = item[cp[p]];
                    if (!item)
                        break;
                    p++;
                }
                if (p == cp.length)
                    return item;
            }
            return null;
        }
        static showReport(report, element, rightToLeft: boolean) {
            var options = new Stimulsoft.Viewer.StiViewerOptions();
            //options.toolbar.showPrintButton = false;
            //options.toolbar.showViewModeButton = false;
            options.toolbar.showOpenButton = false;
            options.toolbar.showAboutButton = false;
            options.appearance.showTooltips = false;
            options.appearance.rightToLeft == rightToLeft;

            var viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
            viewer.showProcessIndicator();
            viewer.report = report;
            viewer.renderHtml(element);

            //var customButton = viewer.jsObject.SmallButton("customButton", "Custom Button", "emptyImage");
            //customButton.image.src = "https://www.stimulsoft.com/images/logo_16.png";
            //customButton.action = function () {
            //    alert("Custom Button Event");
            //}
            //var toolbarTable = viewer.jsObject.controls.toolbar.firstChild.firstChild;
            //var buttonsTable = toolbarTable.rows[0].firstChild.firstChild;
            //var customButtonCell = buttonsTable.rows[0].insertCell(0);
            //customButtonCell.appendChild(customButton);
        }
    }




}